import { handleErrors } from "./errors";

export const pollSyncStatus = (showNotification, callback) => {
    fetch("/api/settings/shopify", {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(handleErrors)
        .then((data) =>{
            const syncInProgress = data?.some((oauth) => oauth.sync_in_progress);
            callback && callback({sync_in_progress: syncInProgress})
        })
        .catch(showNotification);
};

export const pollNetsuiteSyncStatus = (showNotification, callback) => {
    fetch("/api/settings/netsuite", {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(handleErrors)
        .then(callback)
        .catch(showNotification);
};

export const pollNetsuiteIndividualSyncStatus = (orderId, showNotification, callback) => {
    fetch(`/api/draft-invoices/${orderId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(handleErrors)
        .then(callback)
        .catch(showNotification);
};


export const syncNetSuite = (showNotification, onSyncScheduled, onSuccess) => {
    fetch("/api/settings/netsuite", {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(handleErrors)
        .then(data => {
            onSyncScheduled && onSyncScheduled();
            let poll = setInterval(() => pollNetsuiteSyncStatus(
                showNotification,
                (pollStatus) => {
                    if (pollStatus && !pollStatus?.sync_in_progress) { // clear interval when sync is done
                        onSuccess && onSuccess(pollStatus);
                        clearInterval(poll);
                    }
                }
            ), 5000);
            return data;
        })
        .catch(showNotification);
}


export const syncNetSuiteIndividualOrders = (orderId, showNotification, onSyncScheduled, onSuccess) => {
    fetch("/api/settings/netsuite/sync-order", {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            order_id: orderId
        })
    })
        .then(handleErrors)
        .then(data => {
            onSyncScheduled && onSyncScheduled();
            let poll = setInterval(() => pollNetsuiteIndividualSyncStatus(
                orderId,
                showNotification,
                (data) => {
                    if (!data?.sync_in_progress) {
                        onSuccess && onSuccess(data);
                        clearInterval(poll);
                    }
                }
            ), 5000);
            return data;
        })
        .catch(showNotification);
}

export const unlinkShopify = (shopDomain, showNotification, callback) => {
    fetch(`/api/settings/shopify/${shopDomain}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleErrors)
        .then(showNotification)
        .then(() => callback && callback())
        .catch(showNotification);
};

export const unlinkQuickbooks = (showNotification, callback) => {
    fetch("/api/settings/quickbooks", {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(handleErrors)
        .then(showNotification)
        .then(() => callback && callback())
        .catch(showNotification);
};

export const syncShopify = (showNotification, onSyncScheduled, onSuccess, lookbackDays = null) => {
    const body = lookbackDays ? { lookback_days: lookbackDays } : {};
    fetch("/api/settings/shopify", {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    })
        .then(handleErrors)
        .then(data => {
            onSyncScheduled && onSyncScheduled();
            let poll = setInterval(() => pollSyncStatus(showNotification, (data) => {
                if (data && !data?.sync_in_progress) {
                    onSuccess && onSuccess(data);
                    clearInterval(poll);
                }
            }), 5000);
            return data;
        })
        .catch(showNotification);
}


export const syncOrderWithShopify = (orderId, callback, showNotification) => {
    fetch(`/api/draft-invoices/order-sync/${orderId}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(handleErrors)
        .then(data => {
            callback && callback(data);
            return data;
        })
        .catch(showNotification);
}

export const updateShopifySettings = (shopDomain, showNotification, notificationMessage, settings, callback) => {
    const requestBody = {
        ...settings
    };

    fetch(`/api/settings/shopify/${shopDomain}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
    })
        .then(handleErrors)
        .then((data) => {
            callback && callback(data);
            return data;
        })
        .then(() =>
            showNotification({
                message: `${notificationMessage} preferences updated`,
            })
        )
        .catch(showNotification);
};


export const pollHubSpotSyncStatus = (showNotification, callback) => {
    fetch("/api/settings/hubspot", {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(handleErrors)
        .then((data) =>{
            callback && callback({sync_in_progress: !!data?.sync_in_progress})
        })
        .catch(showNotification);
};

export const syncHubSpot = (showNotification, onSyncScheduled, onSuccess, lookbackDays = null) => {
    const body = lookbackDays ? { lookback_days: lookbackDays } : {};
    fetch("/api/settings/hubspot", {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    })
        .then(handleErrors)
        .then(data => {
            onSyncScheduled && onSyncScheduled();
            let poll = setInterval(() => pollHubSpotSyncStatus(showNotification, (data) => {
                if (data && !data?.sync_in_progress) {
                    onSuccess && onSuccess(data);
                    clearInterval(poll);
                }
            }), 5000);
            return data;
        })
        .catch(showNotification);
}

export const unlinkHubSpot = (showNotification, callback) => {
    fetch("/api/settings/hubspot", {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleErrors)
        .then(showNotification)
        .then(() => callback && callback())
        .catch(showNotification);
};

export const updateHubSpotSettings = (showNotification, notificationMessage, settings, callback) => {
    const requestBody = {
        hubspot: settings
    };

    fetch("/api/settings/hubspot", {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
    })
        .then(handleErrors)
        .then((data) => {
            callback && callback(data);
            return data;
        })
        .then(() =>
            showNotification({
                message: `${notificationMessage} preferences updated`,
            })
        )
        .catch(showNotification);
};

export const pollCustomerImportStatus = (callback) => {
    fetch("/api/customers", {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })
        .then(handleErrors)
        .then(callback);
};
